// src/components/Layout.js
import React from "react";
import Sidebar from "./Sidebar";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../fakeAuth";

const Layout = ({ children }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    logoutUser();
    navigate("/login");
  };

  return (
    <div className="flex min-h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <div className="flex justify-end p-4 bg-gray-100 border-b">
          <button onClick={handleLogout}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600">
            Logout
          </button>
        </div>
        <div className="p-6 flex-1 bg-gray-50">{children}</div>
      </div>
    </div>
  );
};

export default Layout;
